
import cep from "cep-promise";

export default {
  name: "ContactForm",

  computed: {
    address: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
  },

  data: () => ({
    isLoading: false,
    cepMatch: false,
    rules: {
      required: (v) => !!v || "Campo obrigatório.",
    },
  }),

  methods: {
    completaEndereco() {
      this.isLoading = true;
      cep(this.address.cep.replace(/[^0-9]/g, ""))
        .then((res) => {
          console.log("cadastrou");
          this.address.uf = res.state;
          this.address.rua = res.street;
          this.address.cidade = res.city;
          this.address.bairro = res.neighborhood;
        })
        .catch((err) => {
          console.log(err);
          this.address = {
            cep: "",
            uf: "",
            rua: "",
            cidade: "",
            bairro: "",
          };
        })
        .finally(() => (this.isLoading = false));
    },
  },

  props: {
    value: Object,
  },
};
